import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { PRODUCTS_SERVICE_URL } from 'src/app/injection-tokens';
import { switchMap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { ProductImportState, ProductImportStateForUpdate } from './product-import-types';
import { ProductDataState, ProductDataStateForUpdate } from './product-data-state-types';

@Injectable({
  providedIn: 'root',
})
export class ProductImportService {
  private readonly productImportStateUrl: string;
  private readonly productDataStateUrl: string;

  constructor(
    @Inject(PRODUCTS_SERVICE_URL) readonly baseServiceUrl: string,
    readonly http: HttpClient
  ) {
    this.productImportStateUrl = baseServiceUrl + '/products/import/state';
    this.productDataStateUrl = baseServiceUrl + '/products/data/state';
  }

  getProductImportState(): Observable<ProductImportState> {
    return this.http.get<ProductImportState>(this.productImportStateUrl);
  }

  updateProductImportState(updateData: ProductImportStateForUpdate): Observable<ProductImportState> {
    return this.http
      .patch<ProductImportState>(this.productImportStateUrl, updateData)
      .pipe(switchMap(() => this.getProductImportState()));
  }

  getProductDataState(): Observable<ProductDataState> {
    return this.http.get<ProductDataState>(this.productDataStateUrl);
  }

  updateProductDataState(updateData: ProductDataStateForUpdate): Observable<ProductDataState> {
    return this.http
      .patch<ProductDataState>(this.productDataStateUrl, {
        ...updateData,
        comment: updateData.comment ?? '',
      })
      .pipe(switchMap(() => this.getProductDataState()));
  }
}
